export default function Division() {
  return (
    <div className="p-4">
      <h1>Division</h1>
    </div>
  );
}
